'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** [
 * Calculates data related to the date fields on a form.
 * @param {Object} formValues - The values in the form.
 * @returns {Object} Object containing restrictions on the date fields.
 */
exports.default = function (formValues) {
  return (// confirm these values
    {
      applicant: {
        dob: {
          min: (0, _moment2.default)().subtract({
            years: 80
          }),
          max: (0, _moment2.default)().subtract(15, 'days')
        }
      },
      applicants: {
        dob: {
          min: (0, _moment2.default)().subtract({
            years: 80
          }),
          max: (0, _moment2.default)().subtract(15, 'days')
        }
      },
      application: {
        departure_date: {
          min: (0, _moment2.default)(),
          max: (0, _moment2.default)().add(364, 'day')
        },
        return_date: {
          min: formValues.application.effective_date ? (0, _moment2.default)(formValues.application.effective_date).add(1, 'day') : (0, _moment2.default)().add(1, 'day'),
          max: formValues.application.effective_date ? (0, _moment2.default)(formValues.application.effective_date).add(364, 'day') : (0, _moment2.default)().add(364, 'day')
        }
      }
    }
  );
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/transformers/msh/livexpat/dates.js
// module id = 1748
// module chunks = 0